
import './App.css';
import Translator from './Translator';

function App() {
  return (
    <div>
     <Translator/>
      
    </div>
  );
}

export default App;
